import React from 'react'

import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import LabelValue from '../../packages/kiti/components/presentation/LabelValue'
import UserPresenterFromId from '../../containers/users/UserPresenterFromId'
import PlacePresenterFromId from '../../containers/places/PlacePresenterFromId'
import { useTranslation } from 'react-i18next'
import { getOperationTypeName } from '../../containers/stocks/select/OperationType'

const Stock = ({ value }) => {
  const { t } = useTranslation(['listStocks', 'common'])
  const OPERATION_TYPE_OPTIONS = getOperationTypeName(t)
  const { amount, fromUserId, item, operationType, toUserId, fromPlaceId, toPlaceId } = value

  return (
    <FlexGrid gutter={0.5} justify="flex-start" align="flex-start">
      <FlexCol flex={0.5}>
        <LabelValue label={t('listStocks:item')} value={item.name}></LabelValue>
      </FlexCol>
      <FlexCol flex={0.5}>
        <LabelValue label={t('listStocks:transfersHistory.table.amount')} value={amount}></LabelValue>
      </FlexCol>
      <FlexCol flex={0.5}>
        <LabelValue
          label={t('listStocks:transfersHistory.table.operationType')}
          value={OPERATION_TYPE_OPTIONS.find(i => i.id === operationType.id).name}
        ></LabelValue>
      </FlexCol>
      {(!!fromUserId || !!toUserId) && (
        <FlexCol flex={0.5}>
          <LabelValue label={t('common:user')}>
            <UserPresenterFromId id={fromUserId || toUserId} size="xsmall" hideIcon hideAvatar />
          </LabelValue>
        </FlexCol>
      )}
      {(!!fromPlaceId || !!toPlaceId) && (
        <FlexCol flex={0.5}>
          <LabelValue label={t('common:place')}>
            <PlacePresenterFromId id={fromPlaceId || toPlaceId} />
          </LabelValue>
        </FlexCol>
      )}
    </FlexGrid>
  )
}

export default Stock
